// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__16tD5","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2T80Z"};